export const ALERT_VARIANT = {
  standard: 'standard',
  filled: 'filled',
  outlined: 'outlined',
};
